import type { ProductTileDataSource } from '@nxt-costco-com/forge-digital-components';

export const FIRST_ITEM_INDEX_TOKEN = '{{firstDisplayedItemIndex}}';
export const LAST_ITEM_INDEX_TOKEN = '{{lastDisplayedItemIndex}}';
export const TOTAL_ITEMS_TOKEN = '{{totalItems}}';

export const BACK_TO_TOP_LABEL_KEY = 'backtotop';
export const PRODUCT_COUNT_LABEL_KEY = 'productcount';

export const KEYWORDS_KEY = 'search_keyword';
export const SEARCH_MATCH_TYPE_KEY = 'search_match_type';

export const URL_KEY = 'url';

export const CATEGORY_FACET_KEY = 'item_category';

/** Shape of product_tile module settings product_display_style used by this app */
export type ProductDisplayStyle = {
    product_card_display_style: string;
    show_reviews: boolean;
    show_action_button: boolean;
    inventory_aware_listings: boolean;
    display_on_zero_inventory?: boolean;
    /** Optional in older library typings, but present on the CMS entry */
    product_tile_data_source?: ProductTileDataSource;
};

/**
 * Fallback when the product_tile module settings entry has no
 * product_display_style. It sets no product_tile_data_source, so the library
 * hook falls back to the Product API and batch inventory in that case.
 */
export const PRODUCT_DISPLAY_STYLE: ProductDisplayStyle = {
    product_card_display_style: 'informative',
    show_reviews: true,
    show_action_button: true,
    inventory_aware_listings: true,
    display_on_zero_inventory: false,
};

export const A11Y_CRITEO_TITLE = 'a11y.criteotitle';
export const A11Y_CRITEO_PRODUCT_TILE_SEPARATOR =
    'a11y.criteoproducttileseparator';

export const ENABLE_MULTI_VARIANT_AVAILABILITY_MESSAGE =
    'enable_multi_variant_availability_message';
export const IS_WAPO_ENABLED = 'warehouse_price_online';
export const ENABLED_WAPO_WAREHOUSES = 'enabled_warehouses_list_wapo';
